import { useEffect } from "react";
import useContent from "../../hooks/useContent";

// Refreshes localStorage("userdata") from /api/me on mount. If role/active/group
// (or name/email/id) drifted, persist and reload so all consumers re-read.
// Silent on failure: safeFetch already redirects on 401.
export default function UserSync() {
  const { getMe } = useContent();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const me = await getMe();
        if (cancelled || !me) return;

        const raw = window.localStorage.getItem("userdata");
        const stored = raw ? JSON.parse(raw) : {};

        const nextGroup = me.group ?? null;
        const nextActive = me.active ?? true;
        const nextRole = me.role ?? "user";

        const changed =
          stored.id !== me.id ||
          stored.name !== me.name ||
          stored.email !== me.email ||
          stored.role !== nextRole ||
          stored.active !== nextActive ||
          (stored.group ?? null) !== nextGroup;

        if (!changed) return;

        const name = me.name ?? stored.name ?? "";
        const initials = name
          .split(" ")
          .map((n) => n[0])
          .filter(Boolean)
          .join("");

        const next = {
          ...stored,
          id: me.id ?? stored.id,
          name,
          email: me.email ?? stored.email,
          initials: initials || stored.initials,
          nickname: name || stored.nickname,
          role: nextRole,
          active: nextActive,
          group: nextGroup,
        };
        window.localStorage.setItem("userdata", JSON.stringify(next));
        window.location.reload();
      } catch {
        // safeFetch handles 401 → redirect; ignore other failures
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return null;
}
